import React from 'react';
import PropTypes from 'prop-types';
import { B2CDomainSelector } from '@yola/webapp-plugins';

function DomainSelector({
  domainName,
  currency,
  captionsOverrides,
  onSelect,
  onDomainSearchFailure,
  onClose,
  onNext = null,
  onSearchStart,
  onSearchPerformed,
  onDomainFieldChange,
  additionalPaymentParams,
  extraPrice = '',
  isSpecialOfferAvailable = false,
  activeSubscriptionTerm = '',
  partnerName,
  isTrialDiscountAvailable = false,
}) {
  return (
    <div className="ws-domain-selector">
      <B2CDomainSelector
        view="content"
        domainName={domainName}
        currency={currency}
        captionsOverrides={captionsOverrides}
        onSelect={onSelect}
        onDomainSearchFailure={onDomainSearchFailure}
        onClose={onClose}
        onNext={onNext}
        onSearchStart={onSearchStart}
        onSearchPerformed={onSearchPerformed}
        onDomainFieldChange={onDomainFieldChange}
        additionalPaymentParams={additionalPaymentParams}
        extraPrice={extraPrice}
        isSpecialOfferAvailable={isSpecialOfferAvailable}
        activeSubscriptionTerm={activeSubscriptionTerm}
        partnerName={partnerName}
        isTrialDiscountAvailable={isTrialDiscountAvailable}
      />
    </div>
  );
}

DomainSelector.propTypes = {
  domainName: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired,
  captionsOverrides: PropTypes.shape().isRequired,
  onSelect: PropTypes.func.isRequired,
  onDomainSearchFailure: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onNext: PropTypes.func,
  onSearchStart: PropTypes.func.isRequired,
  onSearchPerformed: PropTypes.func.isRequired,
  onDomainFieldChange: PropTypes.func.isRequired,
  additionalPaymentParams: PropTypes.shape().isRequired,
  extraPrice: PropTypes.string,
  isSpecialOfferAvailable: PropTypes.bool,
  partnerName: PropTypes.string.isRequired,
  activeSubscriptionTerm: PropTypes.string,
  isTrialDiscountAvailable: PropTypes.bool,
};

export default DomainSelector;
